<template>
  <div
    class="standart-reduced-price text-start"
    data-qa="standart-reduced-price">
    <div
      v-if="dense"
      class="dense h7-text">
      {{ $t('Catalog.Price') }}
      {{ formula_sign }}
      (
      1 +
      <span class=" px-1">
        (
        <span
          class="reduced-price-vars px-1 text-start"
          data-qa="reduced-price-vars">
          {{ used_vars }}
        </span>
        )
      </span>
      / (100% -
      <span class=" px-1">
        (
        <span
          class="reduced-price-vars px-1 text-start"
          data-qa="reduced-price-vars">
          {{ used_vars }}
        </span>
        )
      </span>
      max )
      )
    </div>
    <template
      v-else>
      <div
        class="reduced-price-formula text-start regular"
        :class="!dense ? 'h4-headline' : 'dense h7-text'"
        data-qa="reduced-price-formula">
        <span class="bold">
          {{ bigFirstLetter(type==='price' ? $t('Tenders.GivenPrice') : $t('Tenders.GivenScore')) }}
        </span>
        =
        {{ $t('Catalog.Price') }}
        {{ formula_sign }}
        {{ $t('Tenders.CorrectionFactor') }}
      </div>
      <span
        class="correction-factor-formula text-start regular "
        :class="!dense ? 'h5-headline' : 'dense h7-text'"
        data-qa="correction-factor-formula">
        <span class="bold">
          {{ $t('Tenders.CorrectionFactor') }}
        </span>
        =
        1 +
        <span class=" px-1">
          (
          <span
            class="reduced-price-vars px-1 text-start"
            data-qa="reduced-price-vars">
            {{ used_vars }}
          </span>
          )
        </span>
        / (100% -
        <span class=" px-1">
          (
          <span
            class="reduced-price-vars px-1 text-start"
            data-qa="reduced-price-vars">
            {{ used_vars }}
          </span>
          )
        </span>
        max )
      </span>
    </template>
  </div>
</template>

<script>
import { modalMixin } from 'mixins'

export default {
  name: 'standartReducedPrice',
  mixins: [modalMixin],
  props: {
    variables: Array,
    dense: Boolean
  },
  computed: {
    tender() {
      let new_tender = this.$store.getters.getNewTender
      if ( new_tender?.tenderId ) {
        return new_tender
      }
      return this.$store.getters.getTender || {}
    },
    used_vars() {
      return this.variables.join(' + ') // todo баг якшо переключати з стандартної на свою і назад то можна здублювати змінну в стандартній
    },
    isSale() {
      return this.tender?.biddingType?.isSale
    },
    formula_sign() {
      return this.isSale ? '*' : '/'
    },
    type() {
      return this.tender?.biddingType?.tenderingForPercentage ? 'scale' : 'price'
    }
  }
}
</script>

<style lang="scss" scoped>
.standart-reduced-price .dense {
  max-width: 70%;
  word-break: normal !important;
  white-space: normal;
}

.correction-factor-formula {
  line-height: 30px !important;
  &.dense {
    line-height: 18px !important;
  }
}

.reduced-price-vars {
  height: 30px;
  border-bottom: 3px solid var(--color-main-green);
}
.dense .reduced-price-vars{
  height: 20px;
  border-width: 1px;
}
</style>
